import { computed } from 'vue';
import { useBaseMenuStore } from '@/common/stores/base-menu';
import { useInstanceStore } from '@/common/stores/instance';
import router from '@/common/router';
import { usePaSearchSectionStore } from '@/common/stores/slide-detail';
import { MenuInfo } from '../types';
import { BASE_MENU_VALUE } from '../baseMenu.define';

export interface Props {
  menuInfo: MenuInfo;
  selected?: boolean;
}

export const setup = (props: Props) => {
  const { openSubPanel, closeSubPanel, selectCategory, selectSubPanelMenu } = useBaseMenuStore();
  const { openSearchSection } = usePaSearchSectionStore();
  const { changeGNBInstance } = useInstanceStore();

  const computedChildrenLength = computed(() => props.menuInfo.subMenuList?.length ?? 0);

  const isChildMenuAvailable = computed(() => {
    if (props.menuInfo.value === BASE_MENU_VALUE.DASHBOARD) return true;
    return !!props.menuInfo.subMenuList && props.menuInfo.subMenuList.length;
  });

  const onClickElement = () => {
    if (props.menuInfo.subMenuList) {
      // (우측 패널로 열리는) 하위 메뉴가 있을 경우
      openSubPanel(props.menuInfo);

      // 현재 페이지가 이 메뉴의 하위 메뉴와 일치하면 선택 상태 복원
      const currentPath = router.currentRoute.value.path;
      const currentFullPath = router.currentRoute.value.fullPath;

      const isPathMatch = (path: string) => path === currentPath || path === currentFullPath;

      // 현재 경로와 매칭되는 메뉴 찾기
      props.menuInfo.subMenuList.some((menu) => {
        if (menu.path && isPathMatch(menu.path)) {
          selectSubPanelMenu(menu.value);
          return true;
        }

        if (menu.children) {
          const childMenu = menu.children.find((child) => child.path && isPathMatch(child.path));
          if (childMenu) {
            selectSubPanelMenu(childMenu.value);
            return true;
          }
        }
        return false;
      });
      return;
    }
    // 하위 메뉴가 없을 경우 - 바로 해당 페이지로 이동
    selectCategory({ subMenuValue: props.menuInfo.value });
    if (!props.menuInfo.path) {
      return;
    }

    closeSubPanel();

    const [, rootPath, secondPath] = props.menuInfo.path.split('/');
    if (secondPath === 'multiView' || secondPath === 'singleView') {
      changeGNBInstance(rootPath, secondPath);
      return;
    }

    // PA 섹션 메뉴 클릭 시, 좌측 검색 슬라이드 열림
    if (props.menuInfo.meta?.category === BASE_MENU_VALUE.PA && props.selected) {
      openSearchSection();
      return;
    }

    if (props.menuInfo.path !== router.currentRoute.value.path) router.push(props.menuInfo.path);
  };

  return { computedChildrenLength, isChildMenuAvailable, onClickElement };
};
